(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caynora-produkt"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cay-pdp')) return;

    class CayPdp extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-cay-form]');
        if (!this.form) return;
        this.variantInput = this.form.querySelector('[data-cay-variant]');
        this.atc = this.querySelector('[data-cay-atc]');
        this.error = this.querySelector('[data-cay-error]');
        this.sticky = this.querySelector('[data-cay-sticky]');
        this.stickyBtn = this.querySelector('[data-cay-sticky-btn]');

        this.form.addEventListener('change', (event) => {
          if (event.target.matches('.cay-tier__input')) this.selectVariant(event.target);
        });
        this.form.addEventListener('submit', (event) => this.submit(event));
        this.stickyBtn?.addEventListener('click', () => {
          if (this.form.requestSubmit) this.form.requestSubmit();
          else this.form.submit();
        });

        if (this.sticky && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.sticky.classList.toggle('is-visible', show);
            this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
            this.stickyBtn.tabIndex = show ? 0 : -1;
          });
          this.observer.observe(this.atc);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      selectVariant(input) {
        this.variantInput.value = input.value;
        const available = input.dataset.available === 'true';
        this.querySelectorAll('[data-cay-price]').forEach((el) => (el.textContent = input.dataset.price));
        this.querySelectorAll('[data-cay-compare]').forEach((el) => (el.textContent = input.dataset.compare || ''));
        [this.atc, this.stickyBtn].forEach((btn) => btn && (btn.disabled = !available));
        const stock = this.querySelector('[data-cay-stock-text]');
        if (stock) stock.textContent = available ? stock.dataset.in : stock.dataset.out;
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }

      async submit(event) {
        event.preventDefault();
        if (this.atc.disabled) return;
        this.atc.classList.add('is-loading');
        this.error.hidden = true;
        try {
          const response = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Fehler');
          window.location.href = this.dataset.cartUrl;
        } catch (err) {
          this.error.textContent = err.message || 'Das hat leider nicht geklappt. Bitte versuche es erneut.';
          this.error.hidden = false;
          this.atc.classList.remove('is-loading');
        }
      }
    }

    customElements.define('cay-pdp', CayPdp);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
